// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2vX2i","location":"Header_location__31SSi"};